import bulkImportExcelRequest from 'utils/bulkImportExcelRequest'
import bulkImportShapeFileRequest from 'utils/bulkImportShapeFileRequest'
import { generateApiKey, fetchUserApiKeys, deleteApiKey } from 'api/user'
import { getApiUrl } from 'utils/apiBaseUrl'

const bulkImportPath = '/api/bulk-import'
export const MAX_EXPORT_SITES = 100

async function getApiKey() {
  const response = await fetchUserApiKeys()
  if (response && response.apiKey) {
    return response.apiKey
  } else {
    const response = await generateApiKey()
    if (response && response.apiKey) {
      return response.apiKey
    }
  }
}

export const requestUploadBulkImportExcel = async (
  data,
  isReassessmentsAllowed = false,
  ignoreExistingHabitats = false,
  autoPropose = false
) => {
  const apiKey = await getApiKey()

  return bulkImportExcelRequest(
    `${bulkImportPath}/upload-excel`,
    data,
    apiKey,
    isReassessmentsAllowed,
    ignoreExistingHabitats,
    autoPropose,
    undefined
  )
}

export const requestUploadBulkImportShapeFile = async (data, { autoPropose = false } = {}) => {
  const apiKey = await getApiKey()
  const suffix = autoPropose ? '?autoPropose=true' : ''

  return bulkImportShapeFileRequest(`${bulkImportPath}/upload-shape-file${suffix}`, data, apiKey)
}

export const requestExportSitesExcel = async (siteCodes = [], { blank = false } = {}) => {
  const apiKey = await getApiKey()
  const params = new URLSearchParams()
  if (blank) params.set('blank', 'true')
  else if (siteCodes.length > 0) params.set('siteCodes', siteCodes.join(','))

  return fetch(getApiUrl(`${bulkImportPath}/export-excel?${params}`), {
    method: 'GET',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'x-api-key': apiKey
    }
  })
}
